import ApiService from "@/core/services/api.service";
import { getCsrfRandom } from "@/core/services/store/auth.module";

export const UPLOAD_CHUNKS = "uploadChunks"
const CHUNK_SIZE = 1024 * 1024 * 10; // 5MB
const CHUNK_SIZE_LIMITED = 1024 * 1024 * 1024 * 10; // 5GB

const state = {
    uploadChunksProgress: 0,
};


const getters = {
    getUploadChunksProgress: state => state.uploadChunksProgress,
}

const mutations = {}

const actions = {
    async [UPLOAD_CHUNKS](context, payload) {
        const csrf_token = getCsrfRandom();
        const totalChunks = Math.ceil(payload.file.size / CHUNK_SIZE);
        if( payload.file.size > CHUNK_SIZE_LIMITED ){
            throw new Error('容量は１０GB以内で入力してください。');
        }

        const uploadChunkInitRes = await ApiService.post(`../admin/initiate-upload`, {
            file_name: payload.file.name,
            total_part: totalChunks,
            type_upload: payload.type_upload,
            _csrf: csrf_token
        })

        if (uploadChunkInitRes.data.code !== 200) {
            throw new Error(uploadChunkInitRes.data.data[Object.keys(uploadChunkInitRes.data.data)[0]][0]);
        }
        context.state.uploadChunksProgress = 1;
        // Chunk to upload
        for (let i = 0; i < totalChunks; i++) {
            const start = i * CHUNK_SIZE;
            const end = Math.min(start + CHUNK_SIZE, payload.file.size);
            const chunk = payload.file.slice(start, end);
            const formData = new FormData();
            formData.append("file_path", chunk)
            formData.append("part_number", i + 1)
            formData.append("total_part", totalChunks)
            formData.append("upload_id", uploadChunkInitRes.data.data.upload_id)
            formData.append("type_upload", payload.type_upload)
            formData.append("file_name", payload.file.name)
            formData.append("_csrf", csrf_token)
            const uploadChunkRes = await ApiService.post("../admin/upload-chunk", formData);

            if (uploadChunkRes.data.code !== 200) {
                throw new Error(uploadChunkRes.data.data[Object.keys(uploadChunkRes.data.data)[0]][0]);
            }

            context.state.uploadChunksProgress = Math.round(((i + 1) / totalChunks) * 100);
        }

        const formData = new FormData();
        formData.append("file_name", payload.file.name)
        formData.append("upload_id", uploadChunkInitRes.data.data.upload_id)
        formData.append("type_upload", payload.type_upload)
        formData.append("total_part", totalChunks)
        formData.append("_csrf", csrf_token)
        // Merge after all chunks uploaded
        const uploadChunkComplateRes = await ApiService.post("../admin/complete-upload", formData)
        if (uploadChunkComplateRes.data.code !== 200) {
            throw new Error(uploadChunkComplateRes.data.data[Object.keys(uploadChunkComplateRes.data.data)[0]][0]);
        }
        context.state.uploadChunksProgress = 0;
        return { ...uploadChunkComplateRes.data, total_chunks: totalChunks }
    }
}

export default {
    state,
    actions,
    mutations,
    getters
};